<template>
    <circle
        v-bind="{
            class : 'tool_svgElem',
            id    : tool.id + '-body',
            cx    : tool.coords.pts[0].x, 
            cy    : tool.coords.pts[0].y,
            r     : radius
        }" 
    />
</template>

// =========================================================================================
// =========================================================================================

<script>
import { tools } from '../../mixins/tools';

// =========================================================================================

export default {
    name : 'circCMP',
    mixins: [tools],

    data () {
        return {
        }
    },

    computed: {
        radius() {
            var pt1 = this.tool.coords.pts[0],
                pt2 = this.tool.coords.pts[1]; 
            return Math.sqrt(Math.pow((pt1.x - pt2.x), 2) + Math.pow((pt1.y - pt2.y), 2)) 
        }
    },

    methods: {        
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>